import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, InputNumber, Button, Checkbox, Space, Typography } from 'antd';
import { UserOutlined, SmileOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const UserInfoModal = () => {
    const [visible, setVisible] = useState(false);
    const [isAnonymous, setIsAnonymous] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        const storedName = localStorage.getItem('chat_user_name');
        if (!storedName) {
            setVisible(true);
        }

        const handleOpenModal = () => {
            const currentName = localStorage.getItem('chat_user_name');
            const currentAge = localStorage.getItem('chat_user_age');
            if (currentName) {
                setIsAnonymous(currentName === 'Անանուն');
                form.setFieldsValue({ 
                    name: currentName, 
                    age: currentAge === '0' || currentAge === 0 ? null : parseInt(currentAge) 
                });
            }
            setVisible(true);
        };

        window.addEventListener('open_user_info_modal', handleOpenModal);
        return () => window.removeEventListener('open_user_info_modal', handleOpenModal);
    }, []);

    const handleOk = () => {
        form.validateFields().then(values => {
            let name = values.name;
            let age = values.age;

            if (isAnonymous) {
                name = 'Անանուն';
                age = 0;
            }

            localStorage.setItem('chat_user_name', name);
            localStorage.setItem('chat_user_age', age);
            
            // Dispatch a custom event so other components (like Home or Chat) know info is updated
            window.dispatchEvent(new Event('user_info_updated'));
            
            setVisible(false);
        }).catch(info => {
            console.log('Validate Failed:', info);
        });
    };

    const onAnonymousChange = (e) => {
        setIsAnonymous(e.target.checked);
        if (e.target.checked) {
            form.setFieldsValue({ name: 'Անանուն', age: 0 });
        } else {
            form.setFieldsValue({ name: '', age: null });
        }
    };

    return (
        <Modal
            open={visible}
            title={null}
            footer={null}
            closable={false}
            maskClosable={false}
            centered
            width={400}
            bodyStyle={{ padding: '30px 24px', textAlign: 'center' }}
        >
            <SmileOutlined style={{ fontSize: 48, color: '#1890ff', marginBottom: 20 }} />
            <Title level={3}>Բարի գալուստ AvtoDas</Title>
            <Text type="secondary">Խնդրում ենք լրացնել ձեր տվյալները կայքից օգտվելու համար</Text>
            
            <Form
                form={form}
                layout="vertical"
                style={{ marginTop: 24 }}
                initialValues={{ age: null }}
            >
                <Form.Item
                    name="name"
                    rules={[{ required: !isAnonymous, message: 'Մուտքագրեք ձեր անունը' }]}
                >
                    <Input 
                        prefix={<UserOutlined />} 
                        placeholder="Անուն" 
                        size="large" 
                        disabled={isAnonymous}
                        style={{ borderRadius: 8 }}
                    />
                </Form.Item>
                
                <Form.Item
                    name="age"
                    rules={[{ required: !isAnonymous, message: 'Մուտքագրեք ձեր տարիքը' }]}
                >
                    <InputNumber 
                        placeholder="Տարիք" 
                        size="large" 
                        disabled={isAnonymous}
                        style={{ width: '100%', borderRadius: 8 }}
                        min={1}
                        max={100}
                    />
                </Form.Item>

                <Form.Item style={{ textAlign: 'left' }}>
                    <Checkbox checked={isAnonymous} onChange={onAnonymousChange}>
                        Մնալ անանուն (Անանուն)
                    </Checkbox>
                </Form.Item>

                <Button 
                    type="primary" 
                    size="large" 
                    block 
                    onClick={handleOk}
                    style={{ borderRadius: 8, height: 45, fontWeight: 'bold' }}
                >
                    Հաստատել
                </Button>
            </Form>
        </Modal>
    );
};

export default UserInfoModal;
